import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  companiesListData: {},
  companiesStatuses: [],
  companyStatus: null,
};
const getters = {
  getCompaniesListData: (state) => state.companiesListData,
  getCompaniesStatuses: (state) => state.companiesStatuses,
  getCompanyStatus: (state) => state.companyStatus,
};

const mutations = {
  setCompaniesListData(state, data) {
    state.companiesListData = data;
  },
  setCompaniesStatuses(state, data) {
    state.companiesStatuses = data;
  },
  setCompanyStatus(state, data) {
    state.companyStatus = data;
  },
};

/* eslint-disable no-unused-vars */
const actions = {
  async fetchCompaniesListData({ commit }, credentials) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const searchString = credentials.searchString
        ? encodeURIComponent(credentials.searchString)
        : '';
      const page = credentials.page ? credentials.page : '';
      const companyStatus = credentials.companyStatus
        ? credentials.companyStatus
        : '';
      const data = await axios.get(
        `/companies?page=${page}&searchString=${searchString}&status=${companyStatus}`,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      const companiesListData = {
        ...data.data.data.companies,
        items: enumerateArray(
          data.data.data.companies.items,
          data.data.data.companies.currentPage,
          data.data.data.companies.perPage,
        ),
      };

      commit('setCompaniesListData', companiesListData);
      commit('global/setLoader', false, { root: true });
      return companiesListData;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async fetchCompaniesProperties({ commit }) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get('/companies/properties', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const { status } = data.data.data.properties;

      commit('setCompaniesStatuses', status);
      commit('setCompanyStatus', status[0]);
      commit('global/setLoader', false, { root: true });
      return data;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  // eslint-disable-next-line
  async createCompany({ commit }, companyData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.post('/companies', companyData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async fetchCompanyData({ commit }, companyId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get(`/companies/${companyId}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      return data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  // eslint-disable-next-line
  async editCompany({ commit }, companyData) {
    try {
      const { companyId } = companyData;
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.put(
        `/companies/${companyId}`,
        companyData.data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Lang: lang,
          },
        },
      );

      return data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  // eslint-disable-next-line
  async changeStatus({ commit }, companyId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.patch(`/companies/${companyId}/status`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
          Lang: lang,
        },
      });

      return data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
